import React from 'react';
import { Base, Skeleton } from 'lib/cortiUI';
export const AnswerLoader = () => {
    return (React.createElement(Base, { display: "flex", justifyContent: "space-between", alignItems: "center", gap: 4, flexDirection: "row" },
        React.createElement(Skeleton, { variant: "text", height: 28, width: "30%" }),
        React.createElement(Skeleton, { variant: "rounded", height: 15, width: 45, sx: { borderRadius: '6px' } })));
};
